import { required, minLength } from 'vuelidate/lib/validators'
import { notOnlySpace, mustHaveString } from '@/helpers/validators.js'
import reduce from 'lodash/reduce'
import isPlainObject from 'lodash/isPlainObject'
import assign from 'lodash/assign'
import get from 'lodash/get'

function flattenObject(obj, prefix = '') {
  return reduce(
    obj,
    (acc, value, key) => {
      const flattenedKey = prefix ? `${prefix}.${key}` : key

      if (isPlainObject(value)) {
        assign(acc, flattenObject(value, flattenedKey))
      } else {
        acc[flattenedKey] = value
      }

      return acc
    },
    {}
  )
}

const runFlowValidation = (flow, flowValidations) => {
  const flattenedValidations = flattenObject(flowValidations)
  const validations = Object.entries(flattenedValidations).map(([path, validator]) => {
    const splitPath = path.split('.')
    const attributePath = splitPath.slice(0, splitPath.length - 1).join('.')
    const attributeValue = get(flow, attributePath)
    return validator(attributeValue)
  })
  return !validations.some((validation) => !validation)
}

export const simpleResponseValidation = () => ({
  message: {
    required,
    minLength: minLength(2),
    notOnlySpace,
  },
})

export const forwardToSenderValidation = (flow) => {
  const validation = {
    forward_registers: {
      required,
    },
    send_contact_message: {
      required,
      minLength: minLength(2),
      notOnlySpace,
      mustHaveString: mustHaveString('[link]'),
    },
  }
  if (flow?.select_federative_unit_message?.active) {
    validation.select_federative_unit_message = {
      message: {
        required,
        minLength: minLength(2),
        notOnlySpace,
        mustHaveString: mustHaveString('[menu]'),
      },
    }
  }
  if (flow?.select_city_message?.active) {
    validation.select_city_message = {
      message: {
        required,
        minLength: minLength(2),
        notOnlySpace,
        mustHaveString: mustHaveString('[menu]'),
      },
    }
  }
  if (flow?.select_unit_message?.active) {
    validation.select_unit_message = {
      message: {
        required,
        minLength: minLength(2),
        notOnlySpace,
        mustHaveString: mustHaveString('[menu]'),
      },
    }
  }
  return validation
}

const flowHandleToValidation = {
  simple_response: simpleResponseValidation,
  forward_to_sender: forwardToSenderValidation,
}

export const flowValidator = (handle) => (flow) => {
  // Skip handles that are not the correct type to be validated
  if (flow.handle !== handle) return true
  return runFlowValidation(flow, flowHandleToValidation[handle](flow))
}
